import fridaPic from "@/public/images/artists/frida.png";
import { Artist } from "@/types/types";

export const frida = {
  id: "276",
  name: "Frida",
  image: fridaPic,
  description: `Frida's voice is bright and controlled, with crisp runs, a touch of grit, and a pop-soul edge that lifts a chorus.`,
  previewUrl:
    "https://public-assets.audimeestorage.com/artistPreviews%2Ffrida-preview.mp3",
  meta: {
    free: false,
    new: false,
  },
  filters: {
    gender: "Female",
    tags: {
      primary: ["Belting", "Rock", "Dance"],
      secondary: [],
    },
    pitchRange: {
      categories: {
        low: "Mid",
        high: "High",
      },
      specific: {
        low: 55,
        high: 72,
      },
      sweetSpot: 64,
    },
  },
} as const satisfies Artist;
